// src/pages/Help.js
import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/common/SEO";
import {
  generateFAQSchema,
  generateBreadcrumbSchema,
} from "../../utils/seo/structuredData";
import FAQSection from "../../components/help/FAQSection";

const Help = () => {
  const breadcrumbs = [
    { name: "Home", path: "/home" },
    { name: "Help", path: "/help" },
  ];

  const faqs = [
    {
      question: "How do I create a league?",
      answer:
        "Navigate to the Leagues page and click 'Create League'. Fill in your league details including name, description, and settings. Invite friends via email or share your league code.",
    },
    {
      question: "How do I build my lineup?",
      answer:
        "Go to an upcoming event, select your league, and click 'Build Lineup'. Choose fighters for each weight class and alternates. Submit before the event starts.",
    },
    {
      question: "How is scoring calculated?",
      answer:
        "Points are awarded based on fight outcomes, method of victory, and round finished. Knockouts and submissions earn more points than decisions. Check the Scoring help page for detailed breakdown.",
    },
    {
      question: "Can I join the global competition?",
      answer:
        "Yes! All users are automatically part of the global competition. Build your lineup for any event to compete against players worldwide.",
    },
    {
      question: "When can I change my lineup?",
      answer:
        "You can modify your lineup anytime before the event starts. Once the first fight begins, lineups are locked.",
    },
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [generateFAQSchema(faqs), generateBreadcrumbSchema(breadcrumbs)],
  };

  return (
    <div>
      <SEO
        title="Help & FAQ - DayShift MMA Fantasy League"
        description="Get help with DayShift MMA. Learn how to create leagues, build lineups, understand scoring, and compete in UFC fantasy competitions. Find answers to common questions."
        keywords="UFC fantasy help, MMA fantasy FAQ, how to play fantasy UFC, fantasy MMA guide, UFC fantasy rules, fantasy league help"
        url="/help"
        structuredData={structuredData}
      />

      <h1 className="text-3xl font-bold text-dark-grey mb-8">Help</h1>
      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <Link
          to="/help/events"
          className="block p-6 bg-white rounded-lg shadow-md transform transition-transform duration-200 hover:scale-105"
        >
          <h2 className="text-2xl font-bold text-deep-red">Events</h2>
        </Link>
        <Link
          to="/help/league"
          className="block p-6 bg-white rounded-lg shadow-md transform transition-transform duration-200 hover:scale-105"
        >
          <h2 className="text-2xl font-bold text-deep-red">League</h2>
        </Link>
        <Link
          to="/help/lineup"
          className="block p-6 bg-white rounded-lg shadow-md transform transition-transform duration-200 hover:scale-105"
        >
          <h2 className="text-2xl font-bold text-deep-red">Lineup</h2>
        </Link>
        <Link
          to="/help/scoring"
          className="block p-6 bg-white rounded-lg shadow-md transform transition-transform duration-200 hover:scale-105"
        >
          <h2 className="text-2xl font-bold text-deep-red">Scoring</h2>
        </Link>
        <Link
          to="/rules"
          className="block p-6 bg-white rounded-lg shadow-md transform transition-transform duration-200 hover:scale-105"
        >
          <h2 className="text-2xl font-bold text-deep-red">Rules</h2>
        </Link>
      </div>
      <div className="mt-12">
        <FAQSection />
      </div>
    </div>
  );
};

export default Help;
